import React from 'react';
const items = [{
  emoji: '🎯',
  title: 'Los 6 Tomos de Entrenamiento de FÚTBOL (U4 - U16)',
  desc: 'Desde el despertar motor hasta el rendimiento competitivo. 204 sesiones con objetivos, tiempos y diagramas en HD. Diseñadas para que solo tengas que abrir el PDF y empezar el entrenamiento.',
  color: 'bg-green-500',
  shadow: 'shadow-[0_0_15px_rgba(34,197,94,0.5)]'
}, {
  emoji: '💼',
  title: 'Negocio de FÚTBOL: Academia Élite 360',
  desc: 'El sistema paso a paso para gestionar finanzas, marketing especializado en fútbol y ventas para llenar tus cupos.',
  color: 'bg-blue-500',
  shadow: 'shadow-[0_0_15px_rgba(59,130,246,0.5)]'
}, {
  emoji: '📋',
  title: 'El Registro de Evaluación de FÚTBOL',
  desc: 'Fichas de seguimiento técnico individual e informes mensuales listos para enviar por WhatsApp a los padres.',
  color: 'bg-purple-500',
  shadow: 'shadow-[0_0_15px_rgba(168,85,247,0.5)]'
}, {
  emoji: '📐',
  title: 'Pizarra Táctica y Balón Parado',
  desc: 'Sistemas de juego de fútbol moderno, rotaciones y jugadas ensayadas para ganar partidos el fin de semana.',
  color: 'bg-orange-500',
  shadow: 'shadow-[0_0_15px_rgba(249,115,22,0.5)]'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-26">
            ¿Qué incluye el Sistema "Fútbol Listo Elite 360"?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-27">
            Herramientas digitales en PDF listas para descargar e imprimir hoy
            mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-28">
          {items.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-29">
              <div className={`${item.color} h-1.5 w-full ${item.shadow}`} data-id="element-30" />
              <div className="flex-1 flex flex-col p-8 relative" data-id="element-31">
                {/* Subtle background glow */}
                <div className={`absolute inset-0 ${item.color} opacity-[0.03] group-hover:opacity-[0.08] transition-opacity`} data-id="element-32"></div>

                <span className="text-5xl mb-5 block drop-shadow-2xl relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-33">
                  {item.emoji}
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-text-main leading-snug relative z-10 mb-3" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-text-sec text-base leading-relaxed relative z-10" data-id="element-35">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}